import { styled } from "@mui/system";
import { Grid } from '@mui/material';

export const FormGrid = styled(Grid)({
    '& > *': {
        width: '100%',
        marginTop: '0.5em !important'
    }
});